import { component } from 'picoapp';

export default component(async (node) => {
  const fullVideo = node.querySelector('[data-video-full]');
  const shortVideo = node.querySelector('[data-video-short]');
  const image = node.querySelector('[data-image]');
  const content = node.querySelector('[data-content]');
  const overlay = node.querySelector('[data-overlay]');

  const play = () => {
    if (shortVideo) shortVideo.remove();
    if (image) image.remove();
    if (overlay) overlay.remove();
    content.remove();

    fullVideo.hidden = false;
    fullVideo.play();
  };

  content.addEventListener('click', play);
});
